import { createSelector } from '@ngrx/store';
import { currentLocationState } from '../root';

export const getCurrentLocationValidationState = createSelector(currentLocationState, (currentLocation) => currentLocation.validation);
